import { Injectable } from '@angular/core';
import { ToastComponent } from '@app/components/toast/toast.component';
import { ToastrService } from 'ngx-toastr';

interface ToastDetail {
  title?: string;
  message: string;
  data?: any;
  buttonName?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(private toastr: ToastrService) {}

  info({ title = 'Info', message }: ToastDetail) {
    this.toastr.info(message, title, {
      tapToDismiss: false,
      toastComponent: ToastComponent,
      timeOut: 3000,
      closeButton: false,
      disableTimeOut: true,
    });
  }

  success({ title = 'Success', message }: ToastDetail) {
    this.toastr.success(message, title, {
      tapToDismiss: false,
      toastComponent: ToastComponent,
      timeOut: 3000,
      closeButton: false,
    });
  }

  warning({ title = 'Warning', message }: ToastDetail) {
    this.toastr.warning(message, title, {
      tapToDismiss: false,
      toastComponent: ToastComponent,
      timeOut: 3000,
      closeButton: false,
      disableTimeOut: true,
    });
  }

  error({ title = 'Error', message, data, buttonName }: ToastDetail) {
    this.toastr.error(message, title, {
      tapToDismiss: false,
      toastComponent: ToastComponent,
      timeOut: 9000000,
      closeButton: false,
      disableTimeOut: true,
      payload: { data, buttonName },
    });
  }
}
